export default [
  {
    path: window.pathApp + '/meus-pedidos',
    name: 'meus.pedidos',
    component: () => import('@/components/Pedidos'),
    meta: {
      login: true,
      avisoCarrinho: false,
      title: "Meus Pedidos",
    }
  },
  {
    path: window.pathApp + '/pedidos/:id',
    name: 'meu.pedido',
    component: () => import('@/components/Pedido'),
    meta: {
      login: true,
      avisoCarrinho: false,
      title: "Meu Pedido",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/pedidos.js